import React from 'react'

function Second() {
  return (
    <section className="second">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <p className="text">
                    Αυτό το κοινωνικό καζίνο έχει σχεδιαστεί τόσο για αρχάριους όσο και για έμπειρους παίκτες, προσφέροντας πολλά μπόνους και την ευκαιρία να ανακαλύψετε μυστικά και κρυμμένα δώρα. 
                    Κάθε νέο επίπεδο είναι μια ευκαιρία να βελτιώσετε τις δεξιότητές σας και να απολαύσετε φανταστικά οπτικά εφέ και συναρπαστικούς ήχους. 
                    Το Crazy Monkey Slot είναι κάτι περισσότερο από ένα παιχνίδι - είναι μια ολοκληρωμένη εμπειρία που σας καθηλώνει από την πρώτη περιστροφή.
                </p>
            </div>
            <div className="right-col">
                <img src="/2_(2).jpg" alt="second img"/>
            </div>
        </div>
        <p className="text text-md">
            Ο ελκυστικός σχεδιασμός και η εορταστική ατμόσφαιρα του παιχνιδιού δημιουργούν μια εικονική γιορτή όπου κάθε παίκτης μπορεί να απολαύσει διασκεδαστικό gameplay. 
            Το κοινωνικό καζίνο Crazy Monkey Slot σας προσφέρει την ευκαιρία να βιώσετε τη χαρά της νίκης σε ένα δωρεάν παιχνίδι, ενώ βυθίζεστε σε έναν κόσμο διασκέδασης και ενθουσιασμού. 
            Σε αυτό το παιχνίδι, θα ανακαλύψετε μια αίσθηση άνεσης και απόλαυσης, ξεκλειδώνοντας μυστικά και κρυφά μπόνους σε κάθε νέα συνεδρία.
        </p>
    </div>
</section>

  )
}

export default Second